import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Form, FormGroup, FormControl, Button } from 'react-bootstrap';

import './FoodDetailTable.css';

class FoodDetailTable extends Component {
  constructor(props) {
    super(props);
    this.state = {amount: this.props.servingSize || ''};
    this.orig_ss = this.props.servingSize

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  // to update forms when navigated via history.
  componentWillReceiveProps(nextProps) {
    if(this.props !== nextProps) {
      this.setState({
        amount: nextProps.servingSize || '',
      });
    }
  }

  serving_size_or_CSM(description){
      const food = this.props.food;
      switch(food.serving_type){
          case "SS":
            if(description) return "Recommended Serving Size";
            else return "Serving Size";
            //break;
          case "CSM":
            if(description) return "Typical Common Standard Measure";
            else return "Common Standard Measure";
            //break;
          default:
            return "";
      }
  }

  get_description(description, the_size, unit){
      var size_str = the_size + " " + unit;
      if(description === "None"){
          return size_str;
      }else{
          return description + " = " + size_str;
      }
  }

  renderAltname() {
    const altname = this.props.food.alternate_name;
    if(!Array.isArray(altname) || altname.length === 0) {
      return null;
    }

    return (
      <tr>
        <th>Alternate name(s)</th>
        <td>
          {altname.length === 1
            ? altname[0]
            : <ul>{altname.map((alt, i) => <li key={i}>{alt}</li>)}</ul>
          }
        </td>
      </tr>
    );
  }

  handleChange(event) {
    const amount = event.target.value === '' ? '' : Number(event.target.value);
    if (amount <= 9999 || amount === '') {
      this.setState({amount: amount});
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.amount !== '') {
      this.props.setServingSize(this.state.amount);
    }
  }

  handleReset() {
    this.props.setServingSize();
    this.setState((prevState, props) => ({amount: props.servingSize || ''}));
  }

  render() {
    const food = this.props.food;

    return (
      <Table condensed className="foodDetailTable">
        <tbody>
          <tr>
            <th>FCDB food ID</th>
            <td>{food._id}</td>
          </tr>
          {this.renderAltname()}
          {(food.genus && food.species) &&
            <tr>
              <th>Scientific name</th>
              <td className='scientificName'>{`${food.genus} ${food.species}`}</td>
            </tr>
          }
          {food.description &&
            <tr>
              <th>Description</th>
              <td>{food.description}</td>
            </tr>
          }
          <tr>
            <th>Food group</th>
            <td>{food.group}</td>
          </tr>
          <tr>
            <th>{this.serving_size_or_CSM(false)}</th>
            <td>
              <Form inline onSubmit={this.handleSubmit}>
                <FormGroup controlId="servingSize">
                  <FormControl
                    type='number' min='0' max='9999' step='any'
                    className='servingSizeInput'
                    value={this.state.amount}
                    onChange={this.handleChange}
                  />{food.unit}
                  <Button onClick={this.handleSubmit} bsStyle='primary' bsSize='xsmall'>Update</Button>
                  <Button onClick={this.handleReset} bsStyle='primary' bsSize='xsmall'>Reset</Button>
                </FormGroup>
              </Form>
            </td>
          </tr>
          <tr>
              <th>{this.serving_size_or_CSM(true)}</th>
              <td>
                  {this.get_description(food.measure_description, this.orig_ss,food.unit)}
              </td>
          </tr>
        </tbody>
      </Table>
    );
  }
}

FoodDetailTable.propTypes = {
  food: PropTypes.object.isRequired,
  setServingSize: PropTypes.func.isRequired,
  servingSize: PropTypes.number,
};

export default FoodDetailTable;



// WEBPACK FOOTER //
// ./src/components/foodDetail/FoodDetailTable.js